import React from 'react';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  button: {
    fontSize: 14,
    fontWeight: 400,
    color: '#2962FF',
    marginRight: '16px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  paper: {
    backgroundColor: 'white',
    border: '1px solid #E0E0E0',
    padding: '16px',
    minWidth: 400,
    maxWidth: 800,
    '& > div': {
      maxHeight: 500,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px'
      },
      /* Track */
      '&::-webkit-scrollbar-track': {
        background: '#ebebeb',
        borderRadius: '10px',
        margin: '2px'
      },
      /* Handle */
      '&::-webkit-scrollbar-thumb': {
        background: '#9E9E9E',
        borderRadius: '10px'
      },
      /* Handle on hover */
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#7b7a7a'
      }
    }
  }
}));

export default function GridPopoverWithCloseButton(props) {
  const {
    classes: classesOverride,
    open,
    openModal,
    text,
    options = {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    }
  } = props;
  const classes = useStyles({ classes: classesOverride });
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickComponent = event => {
    setAnchorEl(event.currentTarget);
    openModal();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Button onClick={handleClickComponent} className={classes.button}>
        {text}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          handleClose();
        }}
        classes={{ paper: classes.paper }}
        {...options}
      >
        {props.popoverContent}
      </Popover>
    </React.Fragment>
  );
}
